exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".capsules-component .action-label {\n  font-size: 11px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 2.18;\n  letter-spacing: 0.08px;\n  color: #a3a6b7;\n  margin: 0;\n}\n", ""]);
